$shm_hitalama_components_drafts_list $shm_list_page
	model $shm_hitalama_components_drafts_model
	selected? \
	created? null
	opened? null
	title \Черновики
	minimal_width 224
	add_content <= add_buttons /$mol_view
		<= Add $mol_button_minor
			click? <=> create? null
			sub /
				<= Add_icon $mol_icon_plus
				\Добавить
	body /
		<= Entries $mol_list
			rows <= rows /$mol_view
	Entry* $mol_button_minor
		attr *
			^
			selected <= current* false
		title <= entry_title* \
		click? <=> choose*? null
	Empty $mol_view
		sub / <= empty_label \Черновиков нет
